/**
 * Resolves the default agent for "New Chat".
 * Priority: 1) REACT_APP_DEFAULT_CHAT_AGENT_UUID if set and present in the list,
 * 2) domain "concierge", 3) name "AIMS OS Concierge", 4) last created.
 *
 * @param {Array} agents - List of agents
 * @returns {{ agent: object | null, id: string | null }}
 */
export const getDefaultAgentForNewChat = (agents) => {
  if (!agents?.length) return { agent: null, id: null };
  const conciergeUuid = process.env.REACT_APP_DEFAULT_CHAT_AGENT_UUID;
  if (conciergeUuid) {
    const byEnv = agents.find(
      (a) => (a.uuid || a.id) === conciergeUuid
    );
    if (byEnv) {
      return { agent: byEnv, id: byEnv.uuid || byEnv.id };
    }
  }
  const byDomain = agents.find((a) => a.domain === "concierge");
  if (byDomain) {
    return { agent: byDomain, id: byDomain.uuid || byDomain.id };
  }
  const byName = agents.find((a) => a.name === "AIMS OS Concierge");
  if (byName) {
    return { agent: byName, id: byName.uuid || byName.id };
  }
  const last = [...agents].sort((a, b) => {
    const tA = new Date(a.createdAt || a.created_at || 0).getTime();
    const tB = new Date(b.createdAt || b.created_at || 0).getTime();
    return tB - tA;
  })[0];
  if (!last) return { agent: null, id: null };
  return { agent: last, id: last.uuid || last.id };
};
